module.exports = __webpack_public_path__ + "assets/amp.b5cc65b3.svg";